import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";

const TOAST_DURATION_MS = 2800;

const ToastContext = createContext(() => {});

/** Provides `showToast(message, tone)` to the tree and renders the single toast element. */
export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);

  const showToast = useCallback((message, tone = "ok") => {
    clearTimeout(timerRef.current);
    setToast({ message, tone });
    timerRef.current = setTimeout(() => setToast(null), TOAST_DURATION_MS);
  }, []);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const className = ["toast", toast ? "show" : "", toast?.tone === "error" ? "error" : ""].join(" ").trim();

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <div className={className} role="status" aria-live="polite">
        {toast?.message}
      </div>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
